import {Link, useParams, useNavigate} from 'react-router-dom';
import { ShoppingCart, CreditCard, Share2, Facebook, Twitter,Phone, MapPin, Loader} from 'react-feather';
import SingleProduct from './singleproduct';
import React,{ useState,useEffect, useContext } from 'react';
import { UserContext,CartContext } from '../context';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { ExchangeRateContext } from '../ExchangeRateContext';
import { Helmet } from 'react-helmet-async';
import sicon from "../feature/sicon.jpg";

function ProductDetail(){  
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const location = useLocation();
    const [productData,setProductData]=useState([]);
    const [productImgs,setProductImgs]=useState([]);
    const [ReviewList,setReviewList]=useState([]);
    const [relatedProducts,setrelatedProduct]=useState([]);
    const {product_slug,product_id} = useParams();
    const [cartButtonClickStatus,setcartButtonClickStatus]=useState(false);
    const [ProductInWishlist,setProductInWishlist]=useState(false);
    const [shareContainer, setShareContainer] = useState(false);
    const [SizeError,setSizeError]=useState('');
    const [SizeItems,setSizeItems]=useState([["", ""]]);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const {cartData,setCartData}=useContext(CartContext);
    const userContext=useContext(UserContext);    

    const { exchangeRates, baseCurrency } = useContext(ExchangeRateContext);
    if(exchangeRates==null){window.location.reload();}
    
    const customerId = localStorage.getItem('customer_id');

    const [selectedOption, setSelectedOption] = useState('');
    const [selectedQty, setSelectedQty] = useState(1);
    const [availableQty, setAvailableQty] = useState(0);

    useEffect(()=>{
        fetchData(baseUrl+'/minimal-product/'+product_id);
        fetchTestimonialData(baseUrl+'/productrating/');
        fetchRelatedData(baseUrl+'/related-products/'+product_id,product_id);
        checkProductInCart(product_id);
        if(customerId!==null){checkProductInWishlist(baseUrl+'/check-in-wishlist/',product_id);}  
        fetchSizeItems(baseUrl+'/getsizesu/'+product_id);    
    },[]);

    function fetchData(baseurl) {
        setLoading(true);

        fetch(baseurl)
        .then((response) => response.json())
        .then((data) => {
            setProductData(data); // Set product data
            setProductImgs(data.product_imgs); // Set product images      
            localStorage.setItem('active_vendor_name', data.vendor.shopname);  
            localStorage.setItem('active_vendor_name_link', data.vendor.user.username);  
            // Extract vendor ID from the product data
            const vendorID = data.vendor ? data.vendor.id : null;
            if (vendorID) {
                fetchTrafficData(vendorID); // Pass vendorID to the traffic data function
            }
            setLoading(false);      
        })
        .catch((error) => {
            //console.error('Error fetching product data:', error.message);
        });
    }
    
    const fetchTrafficData = async (vendorID) => {
        try {
            // Fetch IP address without sending credentials
            const ipResponse = await fetch('https://api.ipify.org?format=json', { credentials: 'omit' });
            const ipData = await ipResponse.json();
            const userIP = ipData.ip;
        
            // Gather other details
            const userAgent = navigator.userAgent;
            const deviceType = /Mobi|Android/i.test(userAgent) ? 'Mobile' : 'Desktop';
            const os = navigator.platform;
            const browser = (() => {
                if (userAgent.includes('Chrome')) return 'Chrome';
                if (userAgent.includes('Firefox')) return 'Firefox';
                if (userAgent.includes('Safari')) return 'Safari';
                if (userAgent.includes('MSIE') || userAgent.includes('Trident/')) return 'Internet Explorer';
                return 'Unknown';
            })();
        
            // Check if vendorID is missing or invalid, and provide a fallback value
            if (!vendorID) {
                //console.error('No vendor ID available, using default value.');
                vendorID = 'default_vendor_id'; // You can use a default ID or empty string, depending on your business logic.
            }
    
            // Prepare traffic data
            const trafficData = {
                ip: userIP,
                deviceType,
                os,
                browser,
                product: product_id, // Ensure product_id is defined or passed as needed
                vendor: vendorID, // Pass vendorID as part of the traffic data
            };
        
            // Post the data using fetch
            const response = await fetch(baseUrl + '/prodview/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(trafficData)
            });
        
            if (!response.ok) {
                throw new Error(`Failed to log traffic data: ${response.statusText}`);
            }
            
            //console.log('Traffic data logged successfully');
        } catch (error) {
            //console.error('Error logging traffic data:', error.message);
        }
    };
    
    

    function checkProductInCart(product_id){
        var previousCart=localStorage.getItem('cartData');
        var cartJson=JSON.parse(previousCart);
        if(cartJson!=null){
            cartJson.map((cart)=>{
                if(cart!=null && cart.product.id == product_id){
                    setcartButtonClickStatus(true);
                }
            });
        }
    }

    function fetchTestimonialData(baseurl){
       fetch(baseurl)
       .then((response) => response.json())
       .then((data) => {
           setReviewList(data.results);
       });
   }

   function fetchSizeItems(baseurl){
        fetch(baseurl)
        .then((response) => response.json())
        .then((data) => {
            setSizeItems(data.results);
        });
    }

    function fetchRelatedData(baseurl, product_id) {
        fetch(baseurl)
            .then((response) => response.json())
            .then((data) => {
                // Filter out the product with the specified product_id
                const filteredProducts = data.results.filter((product) => product.id !== product_id);
                setrelatedProduct(filteredProducts);
            });
    }
    

    const cartAddButtonHandler = () => {
        setSizeError("");  
        if (!selectedOption) {
            const sizePickCon = document.querySelector('.size-picker');

            if (sizePickCon) {
                sizePickCon.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }

            setSizeError("Kindly select preferred size.");
            return;
        }
        let previousCart = localStorage.getItem('cartData');
        let cartJson = JSON.parse(previousCart) || [];
        
        const cartData = {
            'product': {
                'id': productData.id,
                'title': productData.title,
                'image': productData.product_imgs[0].image,
                'price': productData.price,
                'currency': productData.currency,
                'size': selectedOption,
                'quantity': selectedQty,
            },
            'user': {
                'id': 1,
            },
            'total_amount': 0,
        };
    
        // Check if the product is already in the cart
        let productExists = false;
        cartJson = cartJson.map(cartItem => {
            if (cartItem && cartItem.product.id === productData.id && cartItem.product.size === selectedOption) {
                productExists = true;
                cartItem.quantity += 1; // Increment quantity if the product exists
                cartItem.total_amount = cartItem.quantity * cartData.product.price; // Update total amount
            }
            return cartItem;
        });
    
        if (!productExists) {
            cartData.total_amount = cartData.quantity * cartData.product.price; // Set initial total amount
            cartJson.push(cartData); // Add the product as a new item if it doesn't exist
        }
    
        localStorage.setItem('cartData', JSON.stringify(cartJson));
        setCartData(cartJson);
        setcartButtonClickStatus(true);
    };
    
    const buyAddButtonHandler = () => {
        setSizeError("");  
        if (!selectedOption) {
            const sizePickCon = document.querySelector('.size-picker');

            if (sizePickCon) {
                sizePickCon.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }

            setSizeError("Kindly select preferred size.");

            setTimeout(() => {
                setSizeError("");
            }, 4000);
            return;
        }
        let previousCart = localStorage.getItem('cartData');
        let cartJson = JSON.parse(previousCart) || [];
        
        const cartData = {
            'product': {
                'id': productData.id,
                'title': productData.title,
                'image': productData.product_imgs[0].image,
                'price': productData.price,
                'currency': productData.currency,
                'size': selectedOption,
                'quantity': selectedQty,
            },
            'user': {
                'id': 1,
            },
            'total_amount': 0  // Initialize quantity as 1
        };
    
        // Check if the product is already in the cart
        let productExists = false;
        cartJson = cartJson.map(cartItem => {
            if (cartItem && cartItem.product.id === productData.id && cartItem.product.size === selectedOption) {
                productExists = true;
                cartItem.quantity += 1; // Increment quantity if the product exists
                cartItem.total_amount = cartItem.quantity * cartData.product.price; // Update total amount
            }
            return cartItem;
        });
    
        if (!productExists) {
            cartData.total_amount = cartData.quantity * cartData.product.price; // Set initial total amount
            cartJson.push(cartData); // Add the product as a new item if it doesn't exist
        }
    
        localStorage.setItem('cartData', JSON.stringify(cartJson));
        setCartData(cartJson);
        setcartButtonClickStatus(true);
        window.location.href='/checkout';
    }
    const cartRemoveButtonHandler = () => {
        var previousCart=localStorage.getItem('cartData');
        var cartJson=JSON.parse(previousCart);
        cartJson.map((cart,index)=>{
            if(cart!=null && cart.product.id == productData.id){
                cartJson.splice(index,1);
            }
        });
        var cartString=JSON.stringify(cartJson);
        localStorage.setItem('cartData',cartString);
        setcartButtonClickStatus(false);
        setCartData(cartJson);
    }

    function saveInWishlist(){
        const formData=new FormData();
        formData.append('customer',customerId);
        formData.append('product',productData.id);
        
        
        //SUBMIT DATA
        axios.post(baseUrl+'/wishlist/',formData)
        .then(function (response){
            if(response.data.id){
                setProductInWishlist(true);
            }   
        })
        .catch(function(error){
            //console.log(error);
        });        
    }
    
    function checkProductInWishlist(baseurl,product_id){
        const customerId = localStorage.getItem('customer_id');
        const formData=new FormData();
        formData.append('customer',customerId);
        formData.append('product',product_id);        
        
        //SUBMIT DATA
        axios.post(baseurl,formData)
        .then(function (response){
            if(response.data.bool==true){
                setProductInWishlist(true);
            }else{setProductInWishlist(false);}    
        })
        .catch(function(error){
            //console.log(error);
        });
    }
    
    function open(){
        setShareContainer(!shareContainer);
    };

    // Function to handle the change in selection
    const handleOptionChange = (event) => {
        const size = event.target.value;

        setSelectedOption(size);

        const selectedSize = SizeItems.find(
            item => item.size === size
        );

        if (selectedSize) {
            setAvailableQty(selectedSize.qty);
            setSelectedQty(1);
        }
    };

    var _stars=[];var _stars0=[];
    const ratingstar = productData.vendor ? Math.floor(productData.vendor.ratings_average) : null;
    const nullratingstar = 5 - ratingstar;

    for(let i=0; i<ratingstar; i++){
        _stars.push('1');
    }

    for(let j=0; j<nullratingstar; j++){
        _stars0.push('1');
    }
           
    var price = productData.offer_price;
    var offer_price = productData.price;
    var currency = productData.currency;

    // Convert price from the product's original currency to the selected base currency
    const productExchangeRate = exchangeRates[currency] || 1;
    const baseExchangeRate = exchangeRates[baseCurrency] || 1;

    // Calculate the converted price
    const convertedPrice = ((price / productExchangeRate) * baseExchangeRate).toFixed(2);
    const convertedOfferPrice = ((offer_price / productExchangeRate) * baseExchangeRate).toFixed(2);
    
    return (
        <>
            <Helmet>
                <title>{productData?.title}</title>
                <meta name="description" content={productData.detail?.slice(0, 150)} />
                <meta property="og:image" content={productImgs?.[0]?.url} />
            </Helmet>
            
            <section className="container mtopcon normal-mt-sctn dtlspg">
                { loading === true ? <p className='text-center'> </p> : <>
                    <div className="row">
                        <div className="col-12 col-md-4 col-lg-4 pt-0 w500">                    
                            <div className="col-12 shadow-sm border border-secondary border-opacity-10 rounded-3 pro-box">
                                <div id="carouselExampleIndicators11" className="carousel carousel-light slide bg-white text-dark" data-bs-ride="true">
                                <div className="carousel-indicators">
                                    {productImgs.map((img, index) => (
                                        <button
                                            key={`indicator-${index}`}
                                            type="button"
                                            data-bs-target="#carouselExampleIndicators11"
                                            data-bs-slide-to={index}
                                            className={`details-indicators ${index === 0 ? "active" : ""}`}
                                            aria-current={index === 0 ? "true" : undefined}
                                            aria-label={`Slide ${index + 1}`}
                                        />
                                    ))}
                                </div>
                                <div className="carousel-inner">
                                {productImgs.map((img, index) => (
                                    <div
                                        key={`carousel-item-${index}`}
                                        className={`carousel-item ${index === 0 ? "active" : ""}`}
                                    >
                                        <img
                                        src={img.image}
                                        className="card-img-top pro-img"
                                        alt="Loading..."
                                        />
                                    </div>
                                ))}

                                </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4 col-lg-4 detail-con">                    
                            <div className='row new-card mb-4'>
                                <div className='col-10'>
                                    <h5 className='text-dark fw800'><b>{productData?.title || 'Product Title'}</b></h5>            

                                    {Number(productData.offer_price) > Number(productData.price) ? (
                                        <>
                                            <b className='pdtlprc normal_price_cross grey-text_888 me-2'>{baseCurrency} {new Intl.NumberFormat().format(Math.round(convertedPrice))}</b>
                                            <b className='pdtlprc normal_price bluetxt'>{baseCurrency} {new Intl.NumberFormat().format(Math.round(convertedOfferPrice))}</b>
                                        </>
                                        ) : (
                                        <>
                                            <h5 className="bluetxt"><b>{baseCurrency}. {new Intl.NumberFormat().format(Math.round(convertedPrice))}</b></h5>
                                        </>
                                    )}
                                </div>
                                <div className='col-2'>
                                    <div className='share-btn' onClick={open}><Share2/></div>
                                    {shareContainer && (
                                        <div className="row sharelinks">
                                            {/* Facebook Share */}
                                            <div className="col-4">
                                                <div 
                                                    className="col-12 fb" 
                                                    onClick={() => {
                                                    const url = window.location.href;
                                                    const text = encodeURIComponent(
                                                        `Hey! I have this brand called ${productData.vendor.user.username} and we've got this cool ${productData.title} going for ${productData.price}. Check it out here: ${url}`
                                                    );
                                                    window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${text}`, '_blank');
                                                    }}
                                                >
                                                    <Facebook />
                                                </div>
                                            </div>

                                            {/* Twitter Share */}
                                            <div className="col-4">
                                                <div 
                                                    className="col-12 tw" 
                                                    onClick={() => {
                                                    const url = window.location.href;
                                                    const text = encodeURIComponent(
                                                        `Hey! I have this brand called ${productData.vendor.user.username} and we've got this cool ${productData.title} for ${productData.price}. Check it out here:`
                                                    );
                                                    window.open(`https://twitter.com/intent/tweet?text=${text}&url=${url}`, '_blank');
                                                    }}
                                                >
                                                    <Twitter />
                                                </div>
                                            </div>

                                            {/* WhatsApp Share */}
                                            <div className="col-4">
                                                <div 
                                                    className="col-12 wa" 
                                                    onClick={() => {
                                                    const url = window.location.href;
                                                    const text = encodeURIComponent(
                                                        `Hey! I have this brand called ${productData.vendor.user.username} and we've got this cool ${productData.title} for ${productData.price}. Check it out here: ${url}`
                                                    );
                                                    window.open(`https://wa.me/?text=${text}`, '_blank');
                                                    }}
                                                >
                                                    <Phone />
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                </div>
                                <div className='col-12 prodetail-con'>
                                    <hr/>
                                    <div className="row body-font prodetail pb-3">
                                        <div
                                            className="txtlight col-12 pl-0"
                                            dangerouslySetInnerHTML={{ __html: productData.detail }}
                                        />
                                    </div>
                                </div>
                                <div className="card vendor-card border-0 shadow-none mt-0 mb-1">
                                    <div className="card-body p-2">

                                        <div className="d-flex align-items-center">

                                            <img
                                                src={sicon}
                                                alt="#"
                                                className="vendor-logo"
                                            />

                                            <div className="ms-3 flex-grow-1">

                                                <div className="d-flex align-items-center">
                                                    <h5 className="mb-0 fw-bold">
                                                        <b className='tcone fw800'>
                                                            {
                                                                productData.vendor && <Link to={`https://kadhr.com/${productData.vendor.user.username}`} className="text-dark">                                             
                                                                {productData.vendor.user.username}</Link> 
                                                            }   
                                                        </b>
                                                    </h5>
                                                    <span className="verified-badge ms-1">
                                                        ✓
                                                    </span>
                                                </div>

                                                <div className="text-muted font8 font-bold" style={{ marginTop: "-0.2em" }}><MapPin className='me-1 p-0' width="10px"/>
                                                    {
                                                        productData.vendor && <>{productData.vendor.address}</>
                                                    }
                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>                            
                            
                            <div className="accordion wishlist-accordion mb-4 card br10" id="wishlistAccordion">
                                <div className="accordion-item border-0 shadow-sm rounded-4 overflow-hidden">

                                    <h5 className="accordion-header">
                                        <button
                                            className="accordion-button collapsed shadow-none"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#wishlistCollapse"
                                            aria-expanded="false"
                                            aria-controls="wishlistCollapse"
                                        >
                                            {ProductInWishlist ? "💖 Saved for Later" : "❤️ Save for Later"}
                                        </button>
                                    </h5>

                                    <div
                                        id="wishlistCollapse"
                                        className="accordion-collapse collapse"
                                        data-bs-parent="#wishlistAccordion"
                                    >
                                        <div className="accordion-body pt-0">

                                            {/* GUEST */}
                                            {userContext == null && (
                                                <>
                                                    <p className="text-muted mb-3">
                                                        Sign in to save products and access them anytime.
                                                    </p>

                                                    <Link to="/customer/login">
                                                        <button className="btn btn-dark w-100">
                                                            Login to Save
                                                        </button>
                                                    </Link>
                                                </>
                                            )}

                                            {/* LOGGED IN - NOT SAVED */}
                                            {(userContext && !ProductInWishlist) && (
                                                <>
                                                    <p className="text-muted mb-3">
                                                        Keep this product in your wishlist and find it again anytime.
                                                    </p>

                                                    <button
                                                        className="btn btn-dark w-100"
                                                        onClick={saveInWishlist}
                                                    >
                                                        ❤️ Add to Wishlist
                                                    </button>
                                                </>
                                            )}

                                            {/* LOGGED IN - SAVED */}
                                            {(userContext && ProductInWishlist) && (
                                                <>
                                                    <div className="alert alert-success mb-3">
                                                        Added to your wishlist.
                                                    </div>

                                                    <p className="text-muted">
                                                        We'll keep it handy so you can come back whenever you're ready.
                                                    </p>

                                                    <div className="row mt-3">
                                                        <div className="col-8">
                                                            <Link
                                                                to="/customer/wishlist"
                                                                className="btn btn-dark w-100"
                                                            >
                                                                View Wishlist
                                                            </Link>
                                                        </div>

                                                        <div className="col-4">
                                                            <button
                                                                className="btn btn-outline-danger w-100"
                                                            >
                                                                Remove
                                                            </button>
                                                        </div>
                                                    </div>
                                                </>
                                            )}

                                        </div>
                                    </div>

                                </div>
                            </div>
                            
                            
                        </div>
                        <div className="col-12 col-md-4 col-lg-4 pt-0 detail-con">
                            <div className='col-12 text-dark'><h5 className='fw800'><b>Select Size</b></h5></div>
                            <div className="mb-0 box-shadow pb-0">
                                <div className="row mb-3">
                                    <ul className="size-picker p-0 m-0">
                                        {SizeItems.map((item, index) => (
                                            <li key={index}>
                                                <label
                                                    className={`size-option ${
                                                        selectedOption === item.size ? "active" : ""
                                                    }`}
                                                >
                                                    <input
                                                        type="radio"
                                                        value={item.size}
                                                        checked={selectedOption === item.size}
                                                        onChange={handleOptionChange}
                                                    />

                                                    <span className='font15 text-dark'>{item.size}</span>
                                                </label>
                                            </li>
                                        ))}
                                    </ul>		
                                    <div className="clear"></div>
                                    {SizeError && <span className='text-danger font8 mt-2 pl-1 font-bold'>{SizeError}</span>}
                                </div>                                
                            </div>

                            {selectedOption && (
                                <div className="mt-3">

                                    <label
                                        className="mb-2 d-block fw-bold"
                                        style={{ fontSize: "0.9em" }}
                                    >
                                        Quantity
                                    </label>

                                    <select
                                        className="form-select border-2"
                                        value={selectedQty}
                                        onChange={(e) =>
                                            setSelectedQty(Number(e.target.value))
                                        }
                                    >
                                        {Array.from(
                                            { length: availableQty },
                                            (_, i) => i + 1
                                        ).map(qty => (
                                            <option key={qty} value={qty}>
                                                {qty}
                                            </option>
                                        ))}
                                    </select>

                                    <div
                                        className="mt-2 text-muted hide"
                                        style={{ fontSize: "0.75em" }}
                                    >
                                        {availableQty} in stock
                                    </div>

                                </div>
                            )}
                        
                            <div className="card-footer border-0 mt-5 hdmobile">
                                {!cartButtonClickStatus && <>
                                        <button type="button"  onClick={buyAddButtonHandler} className="col-5 btn btn-danger prodt stat-top-bg-success border-0 mb-3 btnhght font-bold big-btn0 br50r"><CreditCard className='me-2'/> Buy now</button>
                                        <button type="button" onClick={cartAddButtonHandler} className="col-5 ms-3 btn btn-info prodt text-white mb-3 me-3 btnhght font-bold big-btn0 br50r"><ShoppingCart className='me-2'/> Add to cart </button> 
                                    </>
                                }
                                {cartButtonClickStatus && <>
                                        <button type="button" onClick={cartRemoveButtonHandler} className="col-5 btn font-bold prodt text-danger mb-3 me-3 btnhght br50r">Remove</button> 
                                        <Link to="/checkout"><button type="button" className="col-5 btn btn-info text-white font-bold prodt mb-3 me-3 btnhght br50r"><ShoppingCart className='me-2'/> View cart</button></Link>
                                    </>
                                }
                            </div>

                        </div>
                        {/*Related pros start*/}
                        <div className="col-12 detail-con mthm-5">
                                
                            {relatedProducts.length > 0 && <><h3 className='fw800'>You may also like</h3><br/></>}
                            
                            {   
                                <div className="row mb-6">
                                    {relatedProducts.map((product,index)=><SingleProduct key={index} product={product} />)}
                                </div>
                                
                            }
                        </div>
                        {/*Related pros end*/}
                    </div>
                    <div className={`row btm-nav dtlsbtmnav`}>     
                        {!cartButtonClickStatus && <>
                            <div className='col-6'><button type="button"  onClick={buyAddButtonHandler} className="btn btn-danger prodt stat-top-bg-success border-0 mb-3 me-3 w-100 big-btn0 font-bold"><CreditCard /> Buy now</button></div> 
                            <div className='col-6'><button type="button" onClick={cartAddButtonHandler} className="btn btn-info prodt text-white mb-3 w-100 big-btn0 font-bold"><ShoppingCart /> Add to cart </button></div>
                            </>
                        }
                        {cartButtonClickStatus && <>
                            <div className='col-6'><button type="button" onClick={cartRemoveButtonHandler} className="btn font-bold prodt text-danger mb-3 w-100 big-btn0 font-bold">Remove </button></div>
                            <div className='col-6'><Link to="/checkout"><button type="button" className="btn btn-info prodt text-white mb-3 me-3 w-100 big-btn0 font-bold"><ShoppingCart /> View cart</button></Link></div> 
                            </>
                        }
                    </div>
                </>}
            </section>
        
        </>
    )
}

export default ProductDetail;